/**
 * region for libraries*/
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Grid, Paper, Button } from '@material-ui/core';

/**
 * region for styles*/
import { keywordStyle } from './style/keywordStyle';

/**
 * region for components*/
import LoadingProgress from '../../components/common/LoadingProgress';
import TextResponse from '../../components/common/TextResponse';
import CheckListKeyword from '../../components/keyword/CheckListKeyword';
import Pagination from '../../components/common/Pagination';
import MenuBulkActions from '../../components/common/MenuBulkActions'
import { WizardAddKeywordModal } from '../../components/common/AddKeywordModal/WizardAddKeywordModal'
import MessageModal from '../../components/common/MessageModal'
import { ConfirmationModal } from '../../components/common/ConfirmationModal'

/**
 * region for hepers*/
import Constants from '../../constants/Constants';

class ContainerKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMessageModal: false,
            showAddKeywordModal: false,
            showConfirmationModalUnrelated: false,
            showConfirmationModalDeleted: false,
            showConfirmationModalResearch: false,
            keywordsSelect: []
        }
    }

    callBackMenuItem(option) {
        const self = this;

        const { key } = option;

        if (key !== undefined) {

            const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))

            if (getKeywordInLocalStorage === null ||
                getKeywordInLocalStorage.length === 0) {
                self.setState({ showMessageModal: true })
                return;
            }

            if (key === 1) {
                const keywordsSelect = getKeywordInLocalStorage.map(x => x.IDKEYWORD);
                self.setState({ keywordsSelect: keywordsSelect }, () => {
                    this.handleShowAddKeyword();
                });
            } else if (key === 2) {
                this.handleshowConfirmationModalUnrelated()
            } else if (key === 5) {
                this.handleOnShowConfirmationModalDelete()
            } else if (key === 6) {
                this.handleOnShowConfirmationModalResearch()
            }
        }
    }

    handleChangeCheckbox(keyword) {
        this.props.handleChangeCheckbox(keyword);
    }

    handleOnCloseMessageModal() {
        this.setState({ showMessageModal: false });
    }

    handleShowAddKeyword() {
        this.setState({ showAddKeywordModal: true });
    }

    handleOnCloseAddKeywordModal() {
        this.setState({ showAddKeywordModal: false });
    }

    handleRefreshRelateKeywords() {
        this.setState({ showAddKeywordModal: false }, () => {
            this.props.handleRefreshRelateKeywords()
        });
    }

    handleOnClickConfirmUnrelate() {
        this.props.handleOnClickConfirmUnrelate();
    }

    handleshowConfirmationModalUnrelated() {
        this.setState({ showConfirmationModalUnrelated: true });
    }

    handleOnCloseConfirmationModalUnrelate() {
        this.setState({ showConfirmationModalUnrelated: false });
    }

    handleOnClickConfirmDelete() {
        this.props.handleOnClickConfirmDelete()
    }

    handleOnShowConfirmationModalDelete() {
        this.setState({ showConfirmationModalDelete: true });
    }

    handleOnCloseConfirmationModalDelete() {
        this.setState({ showConfirmationModalDelete: false });
    }

    handleOnShowConfirmationModalResearch() {
        this.setState({ showConfirmationModalResearch: true });
    }

    handleOnCloseConfirmationModalResearch() {
        this.setState({ showConfirmationModalResearch: false });
    }

    handleOnClickConfirmResearch() {
        this.props.handleOnClickConfirmResearch()
    }

    handleClickSelectAll() {
        const { isSelectAll } = this.props
        this.props.handleClickSelectAll(!isSelectAll)
    }

    render() {

        const { keywordsSelect, showMessageModal, showAddKeywordModal, showConfirmationModalUnrelated, showConfirmationModalDelete,showConfirmationModalResearch } = this.state
        const { classes, isSelectAll } = this.props;
        const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

        let TextInitial = "Select the keyword you want to search";
        let TextNoFound = "Sorry, no matching records found";

        return (
            <Grid className={classes.contentAll}
                container
                spacing={0} >
                <Grid item xs={12} md={12} lg={12}>
                    <Paper className={fixedHeightPaper}>
                        <Grid container spacing={0}>
                            <Grid container item xs={12} spacing={0}>
                                {this.props.mode === Constants.MODE_LOADING && <LoadingProgress />}
                                {this.props.mode === Constants.MODE_VIEW && <TextResponse text={TextInitial} />}
                                {(this.props.mode === Constants.MODE_LOADED && this.props.totalFound === 0) &&
                                    <TextResponse text={TextNoFound} />}
                                {(this.props.mode === Constants.MODE_LOADED && this.props.totalFound > 0) &&
                                    (
                                    <Fragment>
                                            <div className={classes.actionContainer}>
                                                <Button onClick={this.handleClickSelectAll.bind(this)} color="primary">{!isSelectAll ? 'Select all' : 'Unselect all'}</Button>
                                                <MenuBulkActions  options={Constants.MENU_BULK_ACTION_OPTIONS} callBackMenuItem={this.callBackMenuItem.bind(this)} />
                                            </div>
                                            <CheckListKeyword
                                                keywordsFound={this.props.keywordsFound}
                                                handleDrawerDetailsOpen={this.props.handleDrawerDetailsOpen}
                                                handleChangeCheckbox={this.handleChangeCheckbox.bind(this)}
                                            />
                                        </Fragment>
                                    )
                                }
                                {(this.props.mode === Constants.MODE_LOADED && this.props.totalFound > 0) &&
                                    <Pagination
                                        totalFound={this.props.totalFound}
                                        pageSize={this.props.pageSize}
                                        pageNumber={this.props.pageNumber}
                                        handleChangePage={this.props.handleChangePage} />}
                                {
                                    showMessageModal && (
                                        <MessageModal
                                            title={"Message"}
                                            text={"Select at least one keyword"}
                                            onClose={this.handleOnCloseMessageModal.bind(this)}
                                            className="modal-md"
                                        />
                                    )
                                }
                                {
                                    showAddKeywordModal && (
                                        <WizardAddKeywordModal
                                            keywordText={""}
                                            titleHeader={"Relate Keywords"}
                                            currentStep={1}
                                            keywordsSelect={keywordsSelect}
                                            onClose={this.handleOnCloseAddKeywordModal.bind(this)}
                                            refreshRelateKeywords={this.handleRefreshRelateKeywords.bind(this)}
                                            className="modal-lg add-keyword" />
                                    )
                                }
                                {
                                    showConfirmationModalUnrelated && (
                                        <ConfirmationModal
                                            title={"Unrelate from categories"}
                                            text={"Are you sure you want to remove all category relationships from the selected keywords?"}
                                            onAccept={this.handleOnClickConfirmUnrelate.bind(this)}
                                            onClose={this.handleOnCloseConfirmationModalUnrelate.bind(this)}
                                            className="modal-lg"
                                        />
                                    )
                                }
                                {
                                    showConfirmationModalDelete && (
                                        <ConfirmationModal
                                            title={"Delete keywords"}
                                            text={"Are you sure you want to delete the selected keywords from the index?"}
                                            onAccept={this.handleOnClickConfirmDelete.bind(this)}
                                            onClose={this.handleOnCloseConfirmationModalDelete.bind(this)}
                                            className="modal-lg"
                                        />
                                    )
                                }
                                {
                                    showConfirmationModalResearch && (
                                        <ConfirmationModal
                                            title={"Research keywords"}
                                            text={"Are you sure you want to research the selected keywords from the index?"}
                                            onAccept={this.handleOnClickConfirmResearch.bind(this)}
                                            onClose={this.handleOnCloseConfirmationModalResearch.bind(this)}
                                            className="modal-lg"
                                        />
                                    )
                                }
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}
ContainerKeyword.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(keywordStyle)(ContainerKeyword);